import { useMutation } from '@tanstack/react-query';
import { getStatisticsWithArchives } from 'api/services/lesson-service';
import { useAuthContext } from './useAuthContext';

const triggerBlobDownload = (blob: Blob, fileName: string): void => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.setAttribute('download', fileName.endsWith('.csv') ? fileName : `${fileName}.csv`);
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};

interface DownloadStatisticsWithArchivesArgs {
    userIds: string[];
    lessonIds: string[];
    fileName: string;
}

export const useStatisticsWithArchives = () => {
    const { userState } = useAuthContext();

    const mutation = useMutation({
        mutationFn: async ({ userIds, lessonIds, fileName }: DownloadStatisticsWithArchivesArgs): Promise<void> => {
            const response = await getStatisticsWithArchives(userState.user.selectedWorkspace.workspaceId, {
                userIds,
                lessonIds,
            });
            if (!response.success || !response.data) {
                throw new Error(response.message ?? 'statistics.archiveReportError');
            }
            triggerBlobDownload(response.data.blob, fileName);
        },
    });

    return {
        downloadStatisticsWithArchives: mutation.mutateAsync,
        gettingStatisticsWithArchives: mutation.isPending,
    };
};
